import { render, staticRenderFns } from "./projectPay.vue?vue&type=template&id=7b74a124&scoped=true&"
import script from "./projectPay.vue?vue&type=script&lang=js&"
export * from "./projectPay.vue?vue&type=script&lang=js&"
import style0 from "./projectPay.vue?vue&type=style&index=0&id=7b74a124&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b74a124",
  null
  
)

export default component.exports